// What draws over structure marks and what takes the press where things overlap (Josh, 10 Oct 2026).
// Draw strokes paint above marks; highlights and every other annotation stay under them. Where a cue overlaps a mark the
// cue takes the press; holding Option/Alt lets the press reach the mark underneath (no tablet equivalent yet).

export function paintsAboveStructureMarks(note) {
    return !!note && note.type === 'free_drawing';
}

export function cueTakesPress({ altKey } = {}) {
    return !altKey;
}

// The drawing's box on the page, by the same rules as free_drawing.vue (notePosLeft/notePosTop/noteWidth/noteHeight)
// when it isn't being dragged, so a draw-only copy lands exactly on the real drawing.
export function drawingBox(note, { pageWidth, pageHeight, selectedScale }) {
    return {
        left: note.x <= 1 ? note.x * pageWidth : note.x * selectedScale,
        top: note.y <= 1 ? note.y * pageHeight : note.y * selectedScale,
        width: selectedScale < 1 ? note.width : note.width * selectedScale,
        height: selectedScale < 1 ? note.height : note.height * selectedScale
    };
}

export default { paintsAboveStructureMarks, cueTakesPress, drawingBox };


// WEBPACK FOOTER //
// ./src/lib/structure-mark-layering.js